var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9971 3.12877C50.8863 4.01791 50.8863 5.45949 49.9971 6.34863L47.0989 9.24692V17.1371C47.0989 18.1818 46.3878 19.0925 45.3743 19.3459L39.9981 20.6899V24.2928C39.9981 24.9989 40.5705 25.5713 41.2766 25.5713C46.4611 25.5713 50.664 29.7742 50.664 34.9587C50.664 40.1432 46.4611 44.346 41.2766 44.346H32.4289V45.538C32.4289 48.5559 29.9825 51.0023 26.9646 51.0023H5.80803C2.79019 51.0023 0.34375 48.5559 0.34375 45.538V13.8032C0.34375 8.77342 4.42116 4.69601 9.45089 4.69601H23.3218C28.3515 4.69601 32.4289 8.77342 32.4289 13.8032V39.7924H41.2766C43.9463 39.7924 46.1104 37.6283 46.1104 34.9587C46.1104 32.289 43.9463 30.1249 41.2766 30.1249C38.0557 30.1249 35.4446 27.5138 35.4446 24.2928V19.1296C35.4305 18.9837 35.4309 18.8388 35.4446 18.6966V15.4046C35.4446 14.8007 35.6844 14.2216 36.1114 13.7946L43.083 6.82301C43.1652 6.72589 43.2553 6.63575 43.3525 6.55359L46.7773 3.12877C47.6664 2.23963 49.108 2.23963 49.9971 3.12877ZM3.98493 26.0257V17.7806H28.7844V26.0257H3.98493ZM21.7154 34.458C22.9728 34.458 23.9922 35.4774 23.9922 36.7348V40.2901C23.9922 41.5475 22.9728 42.5669 21.7154 42.5669C20.458 42.5669 19.4386 41.5475 19.4386 40.2901V36.7348C19.4386 35.4774 20.458 34.458 21.7154 34.458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/Fuel.d2868edf3e5e8203e2d87f419f988375.svg";
export { ForwardRef as ReactComponent };